export const euro = 50;
export const dolar = 45.5;